import React from "react";
import PropTypes from "prop-types";
import withTranslation from "../../translation";
import Notification from "../../Notification";

const mapProductToMessage = {
  Product: "reservation_message",
  Subscription: "subscription_confirmation_message",
  Voucher: "voucher_confirmation_message"
};

const ReservationMessage = ({
  formatTranslation,
  displayReservationMessage,
  items
}) => {
  return displayReservationMessage ? (
    <Notification type="success">
      {formatTranslation(`minibag_${mapProductToMessage[items[0].itemType]}`)}
    </Notification>
  ) : null;
};

ReservationMessage.propTypes = {
  formatTranslation: PropTypes.func.isRequired,
  displayReservationMessage: PropTypes.bool,
  items: PropTypes.array
};

ReservationMessage.defaultProps = {
  displayReservationMessage: false
};

export default withTranslation(ReservationMessage);
